import { safeFetch } from "../utils/safeFetch";


export const getAllSottocategorie = async (token, tenant) => {
  const response = await safeFetch(`/api/subcategories`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    }
  }, 'allSubcategories');

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};

export const getSottocategoriaById = async (id, token, tenant) => {
  const response = await safeFetch(`/api/subcategories/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    }
  }, `subcategory_${id}`);

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};

export const createSottocategoria = async (subcategory, token, tenant) => {
  const response = await safeFetch(`/api/subcategories`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    },
    body: JSON.stringify(subcategory),
  });

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};

export const updateSottocategoria = async (id, subcategory, token, tenant) => {
  const response = await safeFetch(`/api/subcategories/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    },
    body: JSON.stringify(subcategory),
  });

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};

export const deleteSottocategoria = async (id, token, tenant) => {
  const response = await safeFetch(`/api/subcategories/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    }
  });

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  try {
    const text = await response.text();
    return text ? JSON.parse(text) : null;
  } catch (err) {
    console.warn("Risposta non JSON:", err);
    return null;
  }
};
